import { defineStore } from 'pinia'
import { useEzioAPI } from '@ezio/services'
import { useTicketsStore } from '../tickets/store'

export const useTicketCommentsStore = defineStore('ticketComments', () => {
    const { api } = useEzioAPI()

    const create = async (ticketId: string, data: { content: string }) => {
        const response = await api.post('tickets/' + ticketId + '/ticket_comments', {
            ...data,
            include: 'created_by,ticket_assignments,ticket_objects,ticket_comments,ticket_comments.user'
        })
        useTicketsStore().store([response.data])
        return response.data
    }

    const update = async (ticketId: string, commentId: string, data: { content: string }) => {
        const response = await api.put('tickets/' + ticketId + '/ticket_comments/' + commentId, {
            ...data,
            include: 'created_by,ticket_assignments,ticket_objects,ticket_comments,ticket_comments.user'
        })
        useTicketsStore().store([response.data])
        return response.data
    }

    const remove = async (ticketId: string, commentId: string) => {
        const response = await api.delete('tickets/' + ticketId + '/ticket_comments/' + commentId, {
            include: 'created_by,ticket_assignments,ticket_objects,ticket_comments,ticket_comments.user'
        })
        useTicketsStore().store([response.data])
    }
    const reset = () => {

    }

    return {
        create,
        update,
        remove, 
        reset
    }
})
